import type { PropsWithChildren } from "react";

import { useGetCountryCode } from "@/services/api-hooks/geo";
import { useGetMe } from "@/services/api-hooks/user";

export const InitAppAuth = ({ children }: PropsWithChildren) => {
  useGetMe();
  useGetCountryCode();
  return <>{children}</>;
};
